import React from "react";
import Header from "./Header";
import "./styles.css";
import Memegenerator from "./Memegenerator";

function App() {
  return (
    <div className="App">
      <Header />
      <Memegenerator />
    </div>
  );
}

export default App;
